import { QueryClient } from "@tanstack/react-query";

const retryLimit = 5;
const NETWORK_ERROR = "Network request failed";
const FIREBASE_NETWORK_ERROR = "Firebase: Error (auth/network-request-failed).";
const retry = (failureCount: number, error: any) => {
  if (retryLimit < failureCount) {
    return false;
  }
  if (error?.message === NETWORK_ERROR) {
    return true;
  }

  return false;
};

const retryDelay = (failureCount: number, error: any) => {
  if (
    error?.message === NETWORK_ERROR ||
    error?.message === FIREBASE_NETWORK_ERROR
  ) {
    return Math.min(500 * 2 ** failureCount, 3000);
  }
  return 500;
};

export const queryOptions = {
  retry,
  retryDelay,
  staleTime: Infinity,
};

export const mutationOptions = {
  retry,
  retryDelay,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...queryOptions,
    },
    mutations: {
      ...mutationOptions,
    },
  },
});
